const Parse = require('parse');
const { stringify } = require('querystring');
const SERVER_URL = 'https://funsizeapps.b4a.app/';
const APP_ID = 'rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9';
const JAVASCRIPT_KEY = 'xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv';
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;
import lottieAnimation from '../success.json';

var startC, startF, startHH, startButton, btnFilters, btnCancelFilters, btnConfirmFilters, btnRandomize, btnSelectSpot, btnTryAgain, btnGoBack, startModal, filterModal, resultModal, emptyModal, spotsData, filteredSpotData, randomizedSpotData, attributesData, currentlySelectedSpotIndex, spotCards, ticker, lottiePlayer, btnSnacksYes, btnSnacksNo;
const starveEmojis = ['☠️', '🦴', '🫠', '🥺', '🥵', '🤬', '😵', '💀', '🪦', '⚰️'];
const defaultImages = [
    new URL("../images/default/F.png", import.meta.url),
    new URL("../images/default/H.png", import.meta.url),
    new URL("../images/default/C.png", import.meta.url),
    new URL("../images/default/FH.png", import.meta.url),
    new URL("../images/default/CF.png", import.meta.url),
    new URL("../images/default/CH.png", import.meta.url),
    new URL("../images/default/CFH.png", import.meta.url)
  ];
const options = {
    coffee: false,
    food: false,
    happyHour: false,
    indoor: false,
    outdoor: false,
    takeout: false,
    large: false,
    snacks: false
};
const beep = new Audio(new URL('../sounds/beep.mp3', import.meta.url));
const tada = new Audio(new URL('../sounds/tada.mp3', import.meta.url));
const ping = new Audio(new URL('../sounds/pinball.mp3', import.meta.url));

window.addEventListener('load', () => {
    initUI();
    setUIState(false);
    getAttributes().then(() => {
        getSpots().then(() => {
            setUIState(true);
        }).catch(function (e) {
            console.log(e);
            handleParseError('Error when fetching Spots', e);
        });
    }).catch(function (e) {
        console.log(e);
        handleParseError('Error when fetching Attributes', e);
    });
});

const setUIState = (enabled) => {
    if(enabled) {
        startModal.classList.remove('hidden');
        document.getElementById('first-action-bar').classList.remove('hidden');
        document.querySelector('.container').classList.remove('hidden');
        document.querySelector('.loader').classList.add('hidden');
    }
    else {
        startModal.classList.add('hidden');
        document.getElementById('first-action-bar').classList.add('hidden');
        document.querySelector('.container').classList.add('hidden');
        document.querySelector('.loader').classList.remove('hidden');
    }
}

const initUI = () => {
    //startup stuff
    startModal = document.getElementById('startModal');
    startC = document.getElementById('choiceCardCoffee');
    startF = document.getElementById('choiceCardFood');
    startHH = document.getElementById('choiceCardHH');
    startC.addEventListener('click', () => {
        beep.play();
        startC.classList.toggle('selected');
    });
    startF.addEventListener('click', () => {
        beep.play();
        startF.classList.toggle('selected');
    });
    startHH.addEventListener('click', () => {
        beep.play();
        startHH.classList.toggle('selected');
    });
    startButton = document.getElementById('startButton');
    startButton.addEventListener("click", () => {
        beep.play();
        gsap.fromTo(startModal, {x:0}, {x:-window.innerWidth, duration: 0.5, ease:'power2.out'});
        initSpotOptions();
        renderSpots();
    });

    //filter stuff
    filterModal = document.getElementById('filterModal');
    btnFilters = document.getElementById('btn_filters');
    btnCancelFilters = document.querySelector('.filters img');
    btnConfirmFilters = document.getElementById('filter_button');
    btnFilters.addEventListener('click', () => {
        beep.play();
        filterModal.classList.remove('hidden');
        initFilterModal();
    });
    btnCancelFilters.addEventListener('click', () => {
        beep.play();
        filterModal.classList.add('hidden');
        if(filteredSpotData.length < 1) { emptyModal.classList.remove('hidden'); }
    });
    btnConfirmFilters.addEventListener('click', () => {
        beep.play();
        filterModal.classList.add('hidden');
        updateSpotOptions();
        renderSpots();
    });
    btnSnacksYes = document.getElementById('snacks_y');
    btnSnacksYes.addEventListener('click', () => {
        btnSnacksYes.classList.toggle('snack-selected');
        btnSnacksNo.classList.toggle('snack-selected');
    });
    btnSnacksNo = document.getElementById('snacks_n');
    btnSnacksNo.addEventListener('click', () => {
        btnSnacksYes.classList.toggle('snack-selected');
        btnSnacksNo.classList.toggle('snack-selected');
    });

    //main ui stuff
    spotCards = document.querySelector('.card-wrapper').children;
    btnRandomize = document.getElementById('btn_randomize');
    btnRandomize.addEventListener('click', () => {
        beep.play();
        renderSpots();
    });
    btnSelectSpot = document.getElementById('btn_pick');
    btnSelectSpot.addEventListener('click', () => {
        beep.play();
        pickASpot();
    });

    //results stuff
    resultModal = document.getElementById('resultsModal');
    btnTryAgain = document.getElementById('btn_tryAgain');
    btnTryAgain.addEventListener('click', () => {
        beep.play();
        spotCards[currentlySelectedSpotIndex].classList.remove('card-active');
        gsap.fromTo(resultModal, {x: 0}, {x: -window.innerWidth, duration: 0.75, ease: "expo.out(1, 0.5)", onComplete: () => {
            resultModal.classList.add('hidden');
        }});

    });
    lottiePlayer = document.getElementById('lottie');

    //empty stuff
    emptyModal = document.getElementById('emptyModal');
    btnGoBack = document.getElementById('btn_goBack');
    btnGoBack.addEventListener('click', () => {
        initFilterModal();
        emptyModal.classList.add('hidden');
        filterModal.classList.remove('hidden');
    });
}

const initSpotOptions = () => {
    filteredSpotData = spotsData;
    if(startC.classList.contains('selected')){
        filteredSpotData = filteredSpotData.filter(s => { return s.get('Category').includes(startC.dataset.value) });
    }
    if(startF.classList.contains('selected')){
        filteredSpotData = filteredSpotData.filter(s => { return s.get('Category').includes(startF.dataset.value) });
    }
    if(startHH.classList.contains('selected')){
        filteredSpotData = filteredSpotData.filter(s => { return s.get('Category').includes(startHH.dataset.value) });
    }
    options.coffee = startC.classList.contains('selected');
    options.food = startF.classList.contains('selected');
    options.happyHour = startHH.classList.contains('selected');
};

const updateSpotOptions = () => {
    filteredSpotData = spotsData;
    [...document.getElementById('filter_cats').options].forEach(function (element) {
        if(element.selected){
            filteredSpotData = filteredSpotData.filter(s => { return s.get('Category').includes(element.value) });
        }
        if(element.text.startsWith('F')) { options.food =  element.selected; }
        else if(element.text.startsWith('C')) { options.coffee =  element.selected; }
        else { options.happyHour =  element.selected; }
    });
    if(btnSnacksYes.classList.contains('snack-selected')){
        filteredSpotData = filteredSpotData.filter(s => { return s.get('HasSnacks') == true });
    }
    options.snacks = btnSnacksYes.classList.contains('snack-selected');
    [...document.getElementById('filter_sets').options].forEach(function (element) {
        if(element.selected){
            filteredSpotData = filteredSpotData.filter(s => { return s.get('Setting').includes(element.value) });
        }
        if(element.text.startsWith('I')) { options.indoor =  element.selected; }
        else if(element.text.startsWith('O')) { options.outdoor =  element.selected; }
        else { options.takeout =  element.selected; }
    });
    if(document.getElementById('large_y').selected){
        filteredSpotData = filteredSpotData.filter(s => { return s.get('LargeParties') == true });
    }
    options.large = document.getElementById('large_y').selected;
};

const renderSpots = () => {
    if(filteredSpotData.length < 1) {
        emptyModal.classList.remove('hidden');
        return;
    }
    var used = [];
    randomizedSpotData = [];
    if(filteredSpotData.length < 12){
        for(var i = 0; i < 12 - filteredSpotData.length; i++) { randomizedSpotData.push({name: `Starve ${starveEmojis[randomNumber(0,starveEmojis.length)]}`, id: 'starve'}); }
    }
    while (randomizedSpotData.length < 12) {
        var n = randomNumber(0, filteredSpotData.length);
        while (used.includes(n)) {
            n = randomNumber(0, filteredSpotData.length);
        }
        used.push(n);
        randomizedSpotData.push({name: filteredSpotData[n].get('Name'), id: filteredSpotData[n].id});
    }
    used = [];
    while (used.length < 12) {
        var n = randomNumber(0, randomizedSpotData.length);
        while (used.includes(n)) {
            n = randomNumber(0, randomizedSpotData.length);
        }
        used.push(n);
        spotCards[used.length-1].dataset.id = randomizedSpotData[n].id;
        spotCards[used.length-1].innerHTML = randomizedSpotData[n].name;
    }
}

const initFilterModal = () => {
    [...document.getElementById('filter_cats').options].forEach(function (element) {
        if(element.text.startsWith('F')) { element.selected = options.food; }
        else if(element.text.startsWith('C')) { element.selected = options.coffee; }
        else { element.selected = options.happyHour; }
    });
    [...document.getElementById('filter_sets').options].forEach(function (element) {
        if(element.text.startsWith('I')) { element.selected = options.indoor; }
        else if(element.text.startsWith('O')) { element.selected = options.outdoor; }
        else { element.selected = options.takeout; }
    });
    document.getElementById('large_y').selected = options.large;
    document.getElementById('large_n').selected = !options.large;
    if(options.snacks){
        btnSnacksYes.classList.add('snacks-selected');
        btnSnacksNo.classList.remove('snacks-selected');
    }
    else {
        btnSnacksYes.classList.remove('snacks-selected');
        btnSnacksNo.classList.add('snacks-selected');
    }
};

const setRandomSpot = () => {
    if (currentlySelectedSpotIndex) { spotCards[currentlySelectedSpotIndex].classList.remove('card-active'); }
    var n = randomNumber(1, randomizedSpotData.length);
    while (n == currentlySelectedSpotIndex) {
        n = randomNumber(1, randomizedSpotData.length);
    }
    currentlySelectedSpotIndex = n;
    spotCards[currentlySelectedSpotIndex].classList.add('card-active');
};

const startSelectingSpots = (stop) => {
    ping.play();
    setRandomSpot();
    if(stop) {
        while(spotCards[currentlySelectedSpotIndex].dataset.id == 'starve') {
            setRandomSpot();
        }
        window.setTimeout(() => {
            handleSuccess();
        }, 1000)
    }
};

 //picker animation
const pickASpot = () => {
    ticker = 0;
    startSelectingSpots(false);
    gsap.to('.container', {opacity:1, duration: 5, ease:'power2.out', onUpdate: () => {
        ticker++;
        if (ticker % 10 == 0) {
            startSelectingSpots(false);
        }
    }, onComplete: () => {
        startSelectingSpots(true);
    }});
}

const handleSuccess = () => {
    const spot = spotsData.filter(s => {return s.id == spotCards[currentlySelectedSpotIndex].dataset.id})[0];
    const spotOptions = spot.get('Category');
    resultModal.classList.remove('hidden');
    gsap.fromTo(resultModal, {x: window.innerWidth}, {x: 0, duration: 0.5, ease: "expo.out(1, 0.5)"});
    document.getElementById('winner_name').innerHTML = spot.get('Name');
    const item = document.getElementById('winner_img');
    if(!spot.get('Image')){
        if(spotOptions.includes(startC.dataset.value) && spotOptions.includes(startF.dataset.value) && spotOptions.includes(startHH.dataset.value)) { input.src = defaultImages[6]; }
        else if(spotOptions.includes(startC.dataset.value) && spotOptions.includes(startF.dataset.value)) { item.src = defaultImages[4]; }   
        else if(spotOptions.includes(startC.dataset.value) && spotOptions.includes(startHH.dataset.value)) { item.src = defaultImages[5]; }   
        else if(spotOptions.includes(startF.dataset.value) && spotOptions.includes(startHH.dataset.value)) { item.src = defaultImages[3]; }   
        else if(spotOptions.includes(startF.dataset.value)) { item.src = defaultImages[0]; }   
        else if(spotOptions.includes(startC.dataset.value)) { item.src = defaultImages[2]; }   
        else { item.src = defaultImages[1]; }   
    }
    else {
        item.src = spot.get('Image').url();
    }
    if(spot.get('Quote')){
        document.querySelector('.quote-wrapper').classList.remove('hidden');
        document.getElementById('winner_quote').innerHTML = spot.get('Quote').length > 0 ? `"${spot.get('Quote').replace(new RegExp('"', 'g'),'')}"` : '';
        if(spot.get('Quotee')) { document.getElementById('winner_quotee').innerHTML = spot.get('Quotee'); }
    }
    else{
        document.querySelector('.quote-wrapper').classList.add('hidden');
    }
    document.getElementById('winner_address').innerHTML = spot.get('Address');
    document.getElementById('winner_address').href = spot.get('MapUrl');
    if(spot.get('WebsiteUrl')){
        const menu = document.getElementById('winner_menu');
        menu.classList.remove('hidden');
        menu.href = spot.get('WebsiteUrl');
        menu.innerHTML = spot.get('WebsiteUrl').replace('https://www.','').replace('.com/','.com');
    }
    else {
        document.getElementById('winner_menu').classList.add('hidden');
    }
    tada.play();
    lottiePlayer.load(lottieAnimation);
}

async function getSpots() {
    const query = new Parse.Query('WheelSpot');
    query.ascending('Name');
    try {
        spotsData = await query.find();
    } catch (error) {
        throw (error);
    }
}

async function getAttributes() {
    const query = new Parse.Query('WheelSpotAttribute');
    try {
        attributesData = await query.find();
        var input = document.getElementById('filter_cats');
        const categories = attributesData.filter(a => a.get('Type') == 'Category');
        categories.forEach(c => {
            const o = document.createElement('option');
            o.text = c.get('Value');
            o.value = c.id;
            input.add(o)
            if(c.get('Value') === 'Coffee') {
                startC.dataset.value = c.id;
            }
            else if(c.get('Value') === 'Food') {
                startF.dataset.value = c.id;
            }
            else {
                startHH.dataset.value = c.id;
            }
        });

        [...input.options].forEach(function (element) {
            element.addEventListener("mousedown",
                function (e) {
                    e.preventDefault();
                    element.parentElement.focus();
                    this.selected = !this.selected;
                    return false;
                }, false);
        });

        input = document.getElementById('filter_sets');
        const settings = attributesData.filter(a => a.get('Type') == 'Setting');
        settings.forEach(c => {
            const o = document.createElement('option');
            o.text = c.get('Value');
            o.value = c.id;
            input.add(o)
        });

        [...input.options].forEach(function (element) {
            element.addEventListener("mousedown",
                function (e) {
                    e.preventDefault();
                    element.parentElement.focus();
                    this.selected = !this.selected;
                    return false;
                }, false);
        });

    } catch (error) {
        throw (error);
    }
}

function randomNumber(min, max) { 
    return Math.floor(Math.random() * (max - min) + min);
} 

function handleParseError(msg, err) {
    switch (err.code) {
        case Parse.Error.INVALID_SESSION_TOKEN:
            Parse.User.logOut();
            window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}